var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 20A10.011 10.011 0 010 10 10.012 10.012 0 0110 0a10.012 10.012 0 0110 10 10.012 10.012 0 01-10 10zM6 9a1 1 0 00-1 1 1 1 0 001 1h3v3a1 1 0 001 1 1 1 0 001-1v-3h3a1 1 0 001-1 1 1 0 00-1-1h-3V6a1 1 0 00-1-1 1 1 0 00-1 1v3z"
  })));
}

export default SvgIconPlusCircle;